import { DELETE_SUBSTITUTION } from "../../../enums/MyDivision/EmployeeList/EmployeeListTypes";

export const deleteSubstitutionAction = (pid) => {
    return {
        type: DELETE_SUBSTITUTION,
        payload: pid,
    };
};
